const ONETRUST_BANNER_CLOSED_COOKIE = "OptanonAlertBoxClosed";
const ONETRUST_CONSENT_COOKIE = "OptanonConsent";
const ONETRUST_CONSENT_SDK_ID = "onetrust-consent-sdk";
const ONETRUST_SETTINGS_CLASS = "ot-sdk-show-settings";
const CUSTOM_ONETRUST_SETTINGS_SELECTOR = "[data-onetrust-preference-center]";
const COOKIE_POLICY_ID = "ot-sdk-cookie-policy";
const LEGACY_COOKIE_POLICY_ID = "optanon-cookie-policy";
const COOKIE_POLICY_RETRY_LIMIT = 20;
const COOKIE_POLICY_RETRY_DELAY = 250;

const getCookie = (name: string) =>
  document.cookie.split("; ").some((cookie) => cookie.startsWith(`${name}=`));

const hasStoredOneTrustConsent = () =>
  getCookie(ONETRUST_BANNER_CLOSED_COOKIE) ||
  getCookie(ONETRUST_CONSENT_COOKIE) ||
  Boolean(window.OnetrustActiveGroups);

export const openOneTrustPreferenceCenter = () => {
  const toggleInfoDisplay =
    window.OneTrust?.ToggleInfoDisplay || window.Optanon?.ToggleInfoDisplay;

  toggleInfoDisplay?.();
};

const bindOneTrustSettingsLinks = () => {
  const toggleInfoDisplay =
    window.OneTrust?.ToggleInfoDisplay || window.Optanon?.ToggleInfoDisplay;

  if (!toggleInfoDisplay) {
    return;
  }

  document
    .querySelectorAll<HTMLElement>(
      `.${ONETRUST_SETTINGS_CLASS}, ${CUSTOM_ONETRUST_SETTINGS_SELECTOR}`
    )
    .forEach((element) => {
      element.onclick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleInfoDisplay();
      };
    });
};

export const reloadOneTrustBanner = () => {
  if (hasStoredOneTrustConsent()) {
    bindOneTrustSettingsLinks();
    return;
  }

  const otConsentSdk = document.getElementById(ONETRUST_CONSENT_SDK_ID);

  if (otConsentSdk) {
    bindOneTrustSettingsLinks();
    return;
  }

  const OneTrust = window.OneTrust;

  if (!OneTrust?.Init) {
    return;
  }

  OneTrust.Init();

  window.setTimeout(() => {
    OneTrust.LoadBanner?.();
    bindOneTrustSettingsLinks();
  }, 1000);
};

export const clearDuplicateOneTrustCookiePolicySections = () => {
  const policyRoot =
    document.getElementById(COOKIE_POLICY_ID) ||
    document.getElementById(LEGACY_COOKIE_POLICY_ID);

  if (!policyRoot) {
    return;
  }

  const sections = Array.from(policyRoot.querySelectorAll("section"));
  const sectionTitles = new Set<string>();

  sections.forEach((section) => {
    const title = section.querySelector("h3, h4, .ot-sdk-cookie-policy-group");
    const titleText = title?.textContent?.trim();

    if (!titleText) {
      return;
    }

    if (sectionTitles.has(titleText)) {
      section.remove();
      return;
    }

    sectionTitles.add(titleText);
  });
};

export const initializeOneTrustCookiePolicy = (attempt = 0) => {
  const policyRoot =
    document.getElementById(COOKIE_POLICY_ID) ||
    document.getElementById(LEGACY_COOKIE_POLICY_ID);
  const initializeCookiePolicyHtml = window.OneTrust?.initializeCookiePolicyHtml;

  if (policyRoot && initializeCookiePolicyHtml) {
    initializeCookiePolicyHtml(true);
    bindOneTrustSettingsLinks();
    window.setTimeout(clearDuplicateOneTrustCookiePolicySections, 1000);
    return;
  }

  if (attempt >= COOKIE_POLICY_RETRY_LIMIT) {
    return;
  }

  window.setTimeout(
    () => initializeOneTrustCookiePolicy(attempt + 1),
    COOKIE_POLICY_RETRY_DELAY
  );
};

export const updateOneTrustForSpaRoute = (pathname: string) => {
  reloadOneTrustBanner();

  if (pathname === "/cookie-policy" || pathname === "/cookie-policy/") {
    window.setTimeout(initializeOneTrustCookiePolicy, 0);
  }
};
